/**
 * Created by root on 4/10/19.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios'
import { ThemeProvider } from '@workboard/wobo-ui';
import ExternalPublish from './components/popup/extPublishView.js';
import JiraIntegrationPopup from './components/okr/wizard/jiraIntegrationPopup.js';
import ADOPopup from './components/okr/wizard/ADOPopup.js';
import KpiMarketPlaceExternalLoginPopup from './components/okr/wizard/kpiMarketPlaceExternalLoginPopup.js';
import AsanaLogin from './components/okr/wizard/key_results/asaLogin.component.js';
import MyNewIntegrationsComponent from './components/myIntegration/myNewIntegrations.component.js';

const loadSlackPublish = async function (url) {
  await axios.get(url).then(response => {
    const data = response.data.data;
    removeLoader();

    ReactDOM.render(
      <ThemeProvider>
        <div id="data-slack-publish" className="publish-container" style={{ margin: '15px 20px 20px 20px' }}>
          <ExternalPublish data={data} key={`slack_publish-${Math.random()}`} />
        </div>
      </ThemeProvider>,
      document.getElementById('app-portal-container')
    );
  }).catch(err => {
    removeLoader();
    console.log(err)
  })
};

const loadJiraIntegrationPopup = function (
  node,
  action,
  updateParentState = function () {},
  cancelCallback = function () {},
) {
  const domNode = document.querySelector(node);

  const closePopup = () => {
    ReactDOM.unmountComponentAtNode(domNode);
    if (cancelCallback) cancelCallback();
  };

  ReactDOM.render(
    <ThemeProvider>
      <JiraIntegrationPopup
        updateParentState={updateParentState}
        closePopup={closePopup}
        action={action}
      />
    </ThemeProvider>,
    domNode
  );
};

const loadAsanaaIntegrationPopup = function (
  node,
  action,
  updateParentState = function () {}
) {
  const domNode = document.querySelector(node);

  const closePopup = () => {
    ReactDOM.unmountComponentAtNode(domNode);
  };

  ReactDOM.render(
    <div class="kpiSelWrapper width100">
      <AsanaLogin
        action={action}
        closeAsanaLogin={closePopup}
        updateAsanaLogin={updateParentState}
      />
    </div>,
    domNode
  )
}

const loadMyIntegrationComponent = function (node, integrationOptions) {
  ReactDOM.render(<MyNewIntegrationsComponent integrations={integrationOptions}/>, document.querySelector(node));
}

const loadKpiMarketPlaceExternalLoginPopup = function (
  node,
  action,
  kpiType,
  updateParentState = function () {}
) {
  const domNode = document.querySelector(node);

  const closePopup = () => {
    ReactDOM.unmountComponentAtNode(domNode);
    updateParentState();
  };
  const cancelPopup = () => {
    ReactDOM.unmountComponentAtNode(domNode);
  }

  ReactDOM.render(
    <KpiMarketPlaceExternalLoginPopup closePopup={closePopup} cancelPopup={cancelPopup} action={action} kpiType={kpiType}/>,
    domNode,
  );
}

const loadADOPopup = function (node, updateParentState = function () {}) {
  const domNode = document.querySelector(node);

  const closePopup = () => {
    ReactDOM.unmountComponentAtNode(domNode);
  };

  ReactDOM.render(
    <ADOPopup closePopup={closePopup} updateParentState={updateParentState} />,
    domNode
  );
};

window.loadSlackPublish = loadSlackPublish;
window.loadJiraIntegrationPopup = loadJiraIntegrationPopup;
window.loadADOPopup = loadADOPopup;
window.loadKpiMarketPlaceExternalLoginPopup = loadKpiMarketPlaceExternalLoginPopup;
window.loadAsanaaIntegrationPopup = loadAsanaaIntegrationPopup;
window.loadMyIntegrationComponent = loadMyIntegrationComponent;
